import Vue from 'vue'
export function CustomException(value, message = 'Erreur critique') {
    this.value = value
    this.message = message
    Vue.toasted.error(message).goAway(1500)
}
